<template>
  <div>
    <SingleColArticleList v-if="showType === 'single'" :brand-id="brandId" :list="list" :tjjj-prefix="tjjjPre" />
    <HotList v-if="showType === 'multi'" :brand-id="brandId" :hot-list="list" :tjjj-prefix="tjjjPre" />
    <RecommendItem v-if="showType === 'product'" :recommend-list="list" :hidden-title="true" :tjjj-prefix="tjjjPre" />
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
import axios from 'axios';
import HotList from './HotList.vue';
import RecommendItem from './RecommendItem.vue';
import SingleColArticleList from './SingleColArticleList.vue';
import Util from '../lib/util';

Vue.use(Toast);

const failText = '获取推荐列表异常';

export default {
  name: 'RecommendList',
  components: {
    HotList,
    RecommendItem,
    SingleColArticleList,
  },
  props: {
    brandId: {
      type: Number,
      default: -1,
      required: false,
    },
    articleType: {
      type: String,
      default: '',
      required: false,
    },
    zixunId: {
      type: Number,
      default: -1,
      required: false,
    },
    sourceType: {
      type: String,
      default: 'article',
      required: false,
    },
    excludeItemIds: {
      type: Array,
      default: null,
    },
    tjjjPrefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      initStatus: -1,
      showType: 'multi',
      tjjjPre: '',
    };
  },
  watch: {
    brandId: '_initData',
  },
  mounted() {
    this.$nextTick(() => {
      this._initData();
    });
  },
  methods: {
    _validata() {
      if (this.brandId >= 0 && this.zixunId >= 0 && this.articleType) return true;
      return false;
    },
    _initData() {
      if (!this._validata()) return;
      if (this.initStatus !== -1) return;
      const { articleType } = this;
      let recommemdType = '';
      if (articleType === 'BRANDINTRO') {
        recommemdType = 'HOTSALE';
      } else if (['KNOWLEDGE', 'HOTSALE', 'EVALUAT'].indexOf(articleType) > -1) {
        recommemdType = articleType;
      }
      if (this.sourceType === 'article' && articleType === 'EVALUAT') {
        this.showType = 'single';
        this.tjjjPre = `${this.tjjjPrefix}${recommemdType}_`;
      } else if (this.sourceType === 'product') {
        this.showType = this.sourceType;
        this.tjjjPre = `${this.tjjjPrefix}hotsku_`;
      }
      if (this.sourceType === 'article' && recommemdType !== '') {
        this.initStatus = 0;
        const excludeIds = [];
        excludeIds.push(this.zixunId);
        axios.post(`${globalRootUrl}brandhall/recommemd/list`, {
          brandId: this.brandId,
          articleType: recommemdType,
          excludeIds,
          pageSize: 4,
        })
          .then((res) => {
            const { data } = res;
            if (!data || !data.articles) throw new Error('推荐列表异常');
            this.list = data.articles;
            if (data.articles.length > 0) {
              this.$emit('has-data');
            }
          }).catch((err) => {
            console.warn(err);
            Toast.fail(failText);
          });
      } else if (this.sourceType === 'product' && recommemdType !== '') {
        this.initStatus = 0;
        axios.post(`${globalRootUrl}brandhall/recommemd/item/list`, {
          brandId: this.brandId,
          articleType: recommemdType,
          excludeIds: this.excludeItemIds,
          pageSize: 4,
        })
          .then((res) => {
            const { data } = res;
            if (!data || !data.products) throw new Error('推荐列表异常');
            if (Util.isArray(data.products)) {
              data.products.forEach((product) => {
                product.imgUrl = Util.complementImageUrl(product.imgUrl);
              });
              this.list = data.products;
              if (data.products.length > 0) {
                this.$emit('has-data');
              }
            }
          }).catch((err) => {
            console.warn(err);
            Toast.fail(failText);
          });
      }
    },
  },
};
</script>
